import React from 'react';
import { useAppSelector, useAppDispatch } from '../../redux/hooks';
import { toggleCC, pause, play, toggleMute, playbackStatusSelector, ccSelector, mutedSelector, } from '../../redux/slices/ui';
import SkipButton from './Skip';
export default function Controls({ item: page }) {
    const playbackStatus = useAppSelector(playbackStatusSelector);
    const cc = useAppSelector(ccSelector);
    const muted = useAppSelector(mutedSelector);
    const dispatch = useAppDispatch();
    const ccButtonClass = cc ? 'ui-button selected' : 'ui-button';
    const muteButtonClass = muted ? 'ui-button mute selected' : 'ui-button mute';
    const playPauseAriaLabel = playbackStatus === 'paused' ? 'Play' : 'Pause';
    const playPauseButtonClass = playbackStatus === 'paused'
        ? 'ui-button selected play-button'
        : 'ui-button pause-button';
    return (React.createElement("div", { className: "uicontainer" },
        React.createElement("button", { id: "playpause", className: playPauseButtonClass, "aria-label": playPauseAriaLabel, onClick: () => {
                if (playbackStatus === 'paused') {
                    dispatch(play());
                }
                else {
                    dispatch(pause());
                }
            } }, ' '),
        React.createElement("button", { id: "cc", className: ccButtonClass, "aria-pressed": cc, onClick: () => dispatch(toggleCC()) }, "CC"),
        React.createElement("button", { id: "mute", className: muteButtonClass, "aria-pressed": muted, onClick: () => dispatch(toggleMute()) }, "Mute"),
        React.createElement(SkipButton, { item: page })));
}
//# sourceMappingURL=Controls.js.map